import dateTimeUtils from "../../../utils/dateTimeUtils";
import PublishStatusCard from "../PublishStatusCard";

import { type CardBase } from "../../../interfaces/CardPropsBase";

import styles from "./embeddedVideoCard.module.scss";

interface EmbeddedVideoCardItem extends CardBase {
  item: CardBase["item"] & {
    visibility?: boolean;
  };
}

export type EmbeddedVideoCardProps = EmbeddedVideoCardItem;

export const EmbeddedVideoCard = (props: EmbeddedVideoCardProps) => {
  const { item, onSelect, disabled, url, popupMenu, selected } = props;

  return (
    <PublishStatusCard
      id={item.id}
      title={item.title}
      thumbnailUrl={item.thumbnailUrl}
      publisher={item.publisher}
      published={!item.isDraft}
      hasBeenPublished={item.hasBeenPublished}
      disabled={disabled}
      url={url}
      selected={selected}
      popupMenu={popupMenu}
      onSelectionChanged={onSelect}
      className={styles.root}
      isHidden={!item.visibility}
    >
      <div className={styles["date-added"]}>Added {dateTimeUtils.formatDate(item.dateCreated)}</div>
    </PublishStatusCard>
  );
};
